import React, { lazy } from 'react';
import { useInjectReducer } from 'utils/redux-injectors';
import { api } from './slice';

const TelegramBotConfiguration = lazy(() => import('./index'));

export default function TelegramBotConfigurationLoadable() {
  useInjectReducer({
    key: api.reducerPath,
    reducer: api.reducer,
  });
  return <TelegramBotConfiguration />;
}

